import { useRef as $, useMemo as S, useState as U, useEffect as k, useCallback as u } from "react";
import { toArray as n, idsLogger as v, capitalizeFirstLetter as x } from "../helpers.js";
import { LoggerLevels as z } from "../enums.js";
const A = (e, o, s, t) => t ? s ? [...n(o), e] : n(o).filter(
  (c) => c !== e
) : s ? e : void 0, E = (e, o, s) => {
  o && s === void 0 && e(void 0);
}, P = ({
  component: e,
  defaultValue: o,
  multiple: s,
  onChange: t,
  propName: c = "value",
  value: r
}) => {
  const m = $(), i = S(() => r !== void 0, [r]), [f, l] = U(
    s ? n(o) : o
  );
  E(l, m.current, r), m.current = r, k(() => {
    r !== void 0 && o !== void 0 && v(
      `${e}: Please use either the default${x(
        c
      )} prop for uncontrolled components, or the ${c} prop for controlled components, rather than both. If you use both, the value of the component may become unpredictable.`,
      z.Warn
    );
  }, [r, o, e, c]);
  const b = u(
    (d) => {
      i || l(d), t == null || t(d);
    },
    [i, t]
  ), L = u(
    (d, y) => {
      const p = A(
        d,
        r ?? f,
        y,
        s
      );
      i || l(p), t == null || t(p);
    },
    [i, s, t, f, r]
  );
  return {
    isControlled: i,
    setValue: b,
    toggleValue: L,
    value: r ?? f
  };
};
export {
  P as useControlledState
};
